<template>
  <div :class="{ 'vm-sidebar-close': sidebarCollapsed }" class="vm-sidebar">
    <el-scrollbar>
      <div class="logo">
        <el-badge value="3.0">
          <div>eMES</div>
        </el-badge>
      </div>
      <div class="menuSearch">
        <el-input
            v-model="menuName"
            placeholder="搜索"
            prefix-icon="el-icon-search"
            clearable
            @input="inputHandle"/>
      </div>
      <transition>
        <el-menu :default-openeds="defaultOpens" :collapse="sidebarCollapsed" :default-active="$route.path" active-text-color="#fff">
          <sidebar-item v-for="menu in authMenus" :key="menu.menuName" :item="menu" :sidebar-collapsed="sidebarCollapsed"/>
        </el-menu>
      </transition>
    </el-scrollbar>
  </div>
</template>

<script>
  import SidebarItem from "./SidebarItem";

  export default {
    components: { SidebarItem },
    props: {
      sidebarCollapsed: Boolean,
    },
    data() {
      return {
        menuName: "",
        menusCopy: "",
        defaultOpens: [],
        menus: [
          {menuName: "工作流",
           code: "WorkFlow",
           level: 1,
           children: [
             {
               menuName: "对账单待办",
               path:"/workFlow/ReconcileOrder",
               code: "ReconcileOrder:query",
               level: 2,
               authIndex: 312,
             },
             {
               menuName: "现场服务待办",
               path:"/workFlow/AppointmentApprove",
               code: "AppointmentApprove:query",
               level: 2,
               authIndex: 635,
             },
           ],
          },
          {menuName: "销售管理",
           code: "SalesManage",
           level: 1,
           children: [
             {
               menuName: "合同管理",
               path:"/SalesManage/SalesClientContract/ClientContractList",
               code: "ClientContractList:query",
               level: 2,
               authIndex: 37,
             },
             {
               menuName: "合同明细管理",
               path:"/SalesManage/SalesClientContract/ClientContractMaterial",
               code: "ClientContractMaterial:query",
               level: 2,
               authIndex: 756,
             },
             {
               menuName: "销售订单管理",
               path:"/SalesManage/SalesOrder/SalesOrderList",
               code: "SalesOrderList:query",
               level: 2,
               authIndex: 3,
             },
             {
               menuName: "销售订单明细",
               path:"/SalesManage/SalesOrder/SalesOrderDetailList",
               code: "SalesOrderDetailList:query",
               level: 2,
               authIndex: 3,
             },
             {
               menuName: "开票平台",
               path:"/SalesManage/InvoiceApplication/ToDoInvoiceList",
               code: "ToDoInvoiceList:query",
               level: 2,
               authIndex: 239,
             },
             {
               menuName: "开票申请",
               path:"/SalesManage/InvoiceApplication/InvoiceListApplicationList",
               code: "ToDoInvoiceList:query",
               level: 2,
               authIndex: 240,
             },
             {
               menuName: "开票申请明细",
               path: "/SalesManage/InvoiceApplicationDetail/InvoiceApplicationDetailList",
               code: "InvoiceApplicationDetailList:query",
               level: 2,
               authIndex: 60,
             },
             {
               menuName: "客户报价",
               path:"/SalesManage/BusinessApplication/BusinessApplicationList",
               code: "BusinessApplicationList:query",
               level: 2,
               authIndex: 352,
             },
             {
               menuName: "销单变更",
               path: "/SalesManage/SalesOrderChange/SalesOrderChangeList",
               code: "SalesOrderChangeList:query",
               level: 2,
               authIndex: 353,
             },
             {
               menuName: "销售预测",
               path: "/SalesManage/SalesForecast/SalesForecastList",
               code: "SalesForecastList:query",
               level: 2,
               authIndex: 357,
             },
             {
               menuName: "商务待办",
               path: "/SalesManage/SalesOrder/DeliveryBillListToDoBySW",
               code: "DeliveryBillListToDoBySW:query",
               level: 2,
               authIndex: 3,
             },
           ],
          },

          {menuName: "采购管理",
           code: "PurchaseOrderManager",
           level: 1,
           children: [
             {
               menuName: "采购订单",
               path:"/PurchaseOrderManager/PurchaseOrder/PurchaseOrderList",
               code: "PurchaseOrderList:query",
               level: 2,
               authIndex: 399,
             },
             {
               menuName: "采购订单明细",
               code: "PurchaseOrderDetailListV2:query",
               path: "/PurchaseOrderManager/PurchaseOrder/PurchaseOrderDetailListV2",
               level: 2,
               authIndex: 399,
             },
             {
               menuName: "创建送货单",
               path:"/PurchaseOrderManager/PurchaseOrder/PurchaseOrderDetailList",
               code: "PurchaseOrderDetailList:query",
               level: 2,
               authIndex: 438,
             },
             {
               menuName: "创建送货单(要货)",
               path:"/PurchaseOrderManager/PurchaseOrder/PurchaseOrderDetailListYH",
               code: "PurchaseOrderDetailListYH:query",
               level: 2,
               authIndex: 438,
             },
             {
               menuName: "送货单管理",
               path:"/PurchaseOrderManager/PurchaseReceiveList/PurchaseReceiveList",
               code: "PurchaseReceiveList:query",
               level: 2,
               authIndex: 440,
             },
             {
               menuName: "创建对账单",
               path:"/PurchaseOrderManager/ReconcileOrder/CreateReconcileOrder",
               code: "CreateReconcileOrder:query",
               level: 2,
               authIndex: 369,
             },
             {
               menuName: "对账单管理",
               path:"/PurchaseOrderManager/ReconcileOrder/ReconcileOrderList",
               code: "ReconcileOrderList:query",
               level: 2,
               authIndex: 451,
             },
             {
               menuName: "创建生产要货计划",
               path:"/PurchaseOrderManager/PurchasePlan/PurchasePlanAdd",
               code: "PurchasePlanAdd:query",
               level: 2,
               authIndex: 379,
             },
             {
               menuName: "创建发货要货计划",
               path:"/PurchaseOrderManager/PurchasePlan/DeliveryPlanAdd",
               code: "DeliveryPlanAdd:query",
               level: 2,
               authIndex: 396,
             },
             {
               menuName: "要货计划管理",
               path:"/PurchaseOrderManager/PurchasePlan/PurchasePlanList",
               code: "PurchasePlanList:query",
               level: 2,
               authIndex: 457,
             },
             {
               menuName: "委外发料单",
               path: "/StoreManagement/MergeMaterialOrder/MergeOrderList",
               code: "MergeMaterialOrder:query",
               level: 2,
               authIndex: 550,
             },
             {
               menuName: "委外发料单明细",
               path: "/StoreManagement/MergeMaterialOrderDetail/MergeMaterialOrderDetailList",
               code: "MergeMaterialOrderDetail:query",
               level: 2,
               authIndex: 52,
             },

           ],
          },

          {
            menuName: "生产管理",
            code: "ProductionManagement",
            level: 1,
            children: [
              {
                menuName: "生产工单",
                path: "/ProductionManagement/ProductionOrder/ProductionOrderList",
                code: "ProductionOrder:query",
                level: 2,
                authIndex: 12,
              },
              {
                menuName: "生产工单绑定条码",
                path: "/ProductionManagement/ProductionOrderBindBarcode/ProductionOrderBindBarcode",
                code: "ProductionOrderBindBarcode:query",
                level: 2,
                authIndex: 68,
              },
              {
                menuName: "通用扫描",
                path: "/ProductionManagement/ProductionScan/GeneralScan",
                code: "ProductionScan:query",
                level: 2,
                authIndex: 469,
              },
              {
                menuName: "包装扫描",
                path: "/ProductionManagement/ProductionScan/PackScan",
                code: "PackScan:query",
                level: 2,
                authIndex: 470,
              },
              {
                menuName: "卡器包装扫描",
                path: "/ProductionManagement/ProductionScan/NoNeedSerialNoPackScan",
                code: "NoNeedSerialNoPackScan:query",
                level: 2,
                authIndex: 470,
              },
              {
                menuName: "预加工开工扫描",
                path: "/ProductionManagement/ProductionScan/Preprocess",
                code: "ProductionScan:query",
                level: 2,
                authIndex: 471,
              },
              {
                menuName: "组装开工扫描",
                path: "/ProductionManagement/ProductionScan/Assembly",
                code: "ProductionScan:query",
                level: 2,
                authIndex: 472,
              },
              {
                menuName: "关键元器件扫描",
                path: "/ProductionManagement/ProductionScan/KeyComponents",
                code: "ProductionScan:query",
                level: 2,
                authIndex: 473,
              },
              {
                menuName: "工单排产管理",
                path: "/ProductionManagement/ProductionSchedule/ProductionScheduleList",
                code: "ProductionScheduleList:query",
                level: 2,
                authIndex: 316,
              },
            ],
          },
          {
            menuName: "扫描记录管理",
            code: "ScanRecordManagement",
            level: 1,
            children: [
              {
                menuName: "生产组装工序",
                path: "/ProductionManagement/ProductionAssemble/ProductionAssembleList",
                code: "ProductionAssemble:query",
                level: 2,
                authIndex: 749,
              },
              {
                menuName: "生产订单关键器件",
                path: "/ProductionManagement/ComponentBinding/ComponentBindingList",
                code: "ComponentBinding:query",
                level: 2,
                authIndex: 55,
              },
              {
                menuName: "扫描记录",
                path: "/ScanRecordManagement/OrderConfirmationRecord/OrderConfirmationRecordList",
                code: "OrderConfirmationRecordList:query",
                level: 2,
                authIndex: 760,
              },
            ],
          },
          {
            menuName: "发运管理",
            code: "ProductionManagement",
            level: 1,
            children: [
              {
                menuName: "SAP发货单",
                path: "/DeliveryManage/DeliveryBill/DeliveryBillList",
                code: "DeliveryBillList:query",
                level: 2,
                authIndex: 489,
              },
              {
                menuName: "SAP发货单明细",
                path: "/DeliveryManage/DeliveryBillDetail/DeliveryBillDetailList",
                code: "DeliveryBillDetailList:query",
                level: 2,
                authIndex: 61,
              },
              {
                menuName: "仓库待办-发出",
                path: "/DeliveryManage/DeliveryBill/DeliveryBillListToDoByCK",
                code: "DeliveryBillListToDoByCK:query",
                level: 2,
                authIndex: 489,
              },
              {
                menuName: "仓库待办-退回",
                path: "/DeliveryManage/DeliveryBill/DeliveryBillListToDoByBack",
                code: "DeliveryBillListToDoByCK:query",
                level: 2,
                authIndex: 48,
              },
            ],
          },
          {
            menuName: "仓库管理",
            code: "StoreManagement",
            level: 1,
            children: [
              {
                menuName: "预留单管理",
                path: "/StoreManagement/ReserveOrder/ReserveOrderList",
                code: "ReserveOrderList:query",
                level: 2,
                authIndex: 515,
              },
              {
                menuName: "出库单",
                path: "/StoreManagement/OutStockOrder/OutStockOrderList",
                code: "OutStockOrder:query",
                level: 2,
                authIndex: 309,
              },
              {
                menuName: "入库单",
                path: "/StoreManagement/StorageOrder/StorageOrderIndex",
                code: "StorageOrder:query",
                level: 2,
                authIndex: 541,
              },
              {
                menuName: "调拨单",
                path: "/StoreManagement/AllotOrder/AllotOrder",
                code: "AllotOrder:query",
                level: 2,
                authIndex: 545,
              },
              {
                menuName: "物料库存查询",
                path: "/StoreManagement/MaterialWarehousing/SapMaterialWarehousingList",
                code: "SapMaterialWarehousing:query",
                level: 2,
                authIndex: 552,
              },
              {
                menuName: "仓库预登记",
                path: "/StoreManagement/WarehousePreRegistration/WarehousePreRegistrationList",
                code: "WarehousePreRegistration:query",
                level: 2,
                authIndex: 26,
              },
              {
                menuName: "发货单明细序列",
                path: "/StoreManagement/DeliveryBillDetailSerialNo/DeliveryBillDetailSerialNoList",
                code: "DeliveryBillDetailSerialNo:query",
                level: 2,
                authIndex: 63,
              },
            ],
          },
          {
            menuName: "售后管理",
            code: "AfterSaleManage",
            level: 1,
            children: [
              {
                menuName: "客诉信息登记",
                path: "/AfterSaleManage/ComplaintInfo/ComplaintInfoList",
                code: "ComplaintInfo:query",
                level: 2,
                authIndex: 631,
              },
              {
                menuName: "现场服务申请",
                path: "/AfterSaleManage/AppointmentOrder/AppointmentOrderList",
                code: "AppointmentOrder:query",
                level: 2,
                authIndex: 631,
              },
              {
                menuName: "退换货申请",
                path: "/AfterSaleManage/ReplacementBill/ReplacementBillList",
                code: "ReplacementBillList:query",
                level: 2,
                authIndex: 560,
              },
            ],
          },
          {
            menuName: "质量管理",
            code: "inspection",
            level: 1,
            children: [
              {
                menuName: "改进调查单",
                path: "/ImprovedSurvey/ImprovedSurveyList",
                code: "ImprovedSurveyList:query",
                level: 2,
                authIndex: 0,
              },
              {
                menuName: "来料检验",
                path: "/inspection/inspectionIncoming/InspectionIncomingList",
                code: "InspectionIncomingList:query",
                level: 2,
                authIndex: 571,
              },
              {
                menuName: "供应商质量扣款",
                path: "/inspection/Amerce/AmerceList",
                code: "AmerceList:query",
                level: 2,
                authIndex: 576,
              },
              {
                menuName: "过程检验",
                path: "/inspection/processException/ProcessExceptionList",
                code: "ProcessExceptionList:query",
                level: 2,
                authIndex: 581,
              },
              {
                menuName: "出货检验",
                path: "/inspection/shipmentInspect/ShipmentInspectList",
                code: "ShipmentInspectList:query",
                level: 2,
                authIndex: 586,
              },
            ],
          },
          {
            menuName: "维修管理",
            code: "maintenanceManage",
            level: 1,
            children: [
              {
                menuName: "生产报修",
                path: "/maintenanceManage/repairRegistrationBG/ProductionBGIndex",
                code: "repairRegistrationBG:query",
                level: 2,
                authIndex: 588,
              },
              {
                menuName: "待修清单",
                path: "/maintenanceManage/repairRegistrationBG/FixToDoSCList",
                code: "fixToDoSCList:query",
                level: 2,
                authIndex: 588,
              },
              {
                menuName: "生产维修",
                path: "/maintenanceManage/repairRegistrationSC/RepairRegistrationSCList",
                code: "repairRegistrationSC:query",
                level: 2,
                authIndex: 611,
              },
              {
                menuName: "售后接机",
                path: "/maintenanceManage/repairRegistrationJJ/RepairRegistrationJJList",
                code: "repairRegistrationJJ:query",
                level: 2,
                authIndex: 475,
              },
              {
                menuName: "售后签收",
                path: "/maintenanceManage/repairRegistrationQS/RepairRegistrationQSList",
                code: "repairRegistrationQS:query",
                level: 2,
                authIndex: 592,
              },
              {
                menuName: "售后维修",
                path: "/maintenanceManage/repairRegistrationCS/RepairRegistrationCSList",
                code: "repairRegistrationCS:query",
                level: 2,
                authIndex: 596,
              },
            ],
          },
          {
            menuName: "设备管理",
            code: "",
            level: 1,
            children: [
              {
                menuName: "设备清单",
                code: "TaskProcessInspection:query",
                level: 2,
                authIndex: 502,
              },
            ],
          },
          {
            menuName: "物料管理",
            code: "",
            level: 1,
            children: [
              {
                menuName: "物料清单",
                path: "/information/Material/MaterialList",
                code: "material:query",
                level: 2,
                authIndex: 123,
              },
              {
                menuName: "价格清单",
                path: "/information/MaterialPrice/MaterialPriceList",
                code: "MaterialPriceList:query",
                level: 2,
                authIndex: 17,
              },
              {
                menuName: "价格申请列表",
                path: "/information/MaterialPrice/MaterialPriceApplicationList",
                code: "MaterialPriceApplicationList:query",
                level: 2,
                authIndex: 18,
              },
              {
                menuName: "物料BOM",
                path: "/information/BomManage/BomList",
                code: "bomManage:query",
                level: 2,
                authIndex: 652,
              },
              {
                menuName: "物料条码",
                path: "/information/MaterialSnRule/MaterialSnRuleList",
                code: "materialSnRule:query",
                level: 2,
                authIndex: 19,
              },
              {
                menuName: "条码规则",
                path: "/information/BarCodeRules/BarCodeRulesList",
                code: "barCodeRules:query",
                level: 2,
                authIndex: 20,
              },
            ],
          },
          {
            menuName: "工艺管理",
            code: "",
            level: 1,
            children: [
              {
                menuName: "工艺路线",
                path: "/information/SapBaseRoute/SapBaseRouteList",
                code: "SapBaseRouteList:query",
                level: 2,
                authIndex: 762,
              },
              {
                menuName: "设备绑定工序",
                path: "/information/DeviceBinding/DeviceBindingList",
                code: "DeviceBindingList:query",
                level: 2,
                authIndex: 22,
              },
              {
                menuName: "ESOP文件",
                path: "/information/ESOPV2/EsopList",
                code: "EsopList:query",
                level: 2,
                authIndex: 22,
              },
            ],
          },
          {
            menuName: "看板管理",
            code: "",
            level: 1,
            children: [
              {
                menuName: "菜单1",
                code: "TaskProcessInspection:query",
                level: 2,
                authIndex: 852,
              },
            ],
          },
          {
            menuName: "统计分析",
            code: "",
            level: 1,
            children: [
              {
                menuName: "菜单1",
                code: "TaskProcessInspection:query",
                level: 2,
                authIndex: 902,
              },
            ],
          },
          {
            menuName: "基本信息",
            code: "information",
            level: 1,
            children: [
              {
                menuName: "供应商管理",
                path: "/information/SupplierManage/SupplierManageList",
                code: "supplierManage:query",
                level: 2,
                authIndex: 111,
              },
              {
                menuName: "客户管理",
                path: "/information/Customer/CustomerList",
                code: "CustomerList:query",
                level: 2,
                authIndex: 100,
              },
              {
                menuName: "客户物料管理",
                path: "/information/Customer/CustomerMaterialMappingList",
                code: "CustomerMaterialMappingList:query",
                level: 2,
                authIndex: 105,
              },
              {
                menuName: "部门管理",
                path: "/information/Department/DepartmentList",
                code: "department:query",
                level: 2,
                authIndex: 113,
              },
              {
                menuName: "员工管理",
                path: "/information/Employee/EmployeeList",
                code: "employee:query",
                level: 2,
                authIndex: 118,
              },
              {
                menuName: "月结时间管理",
                path: "/information/CloseBookDate/CloseBookDateList",
                code: "closeBookDate:query",
                level: 2,
                authIndex: 765,
              },
            ],
          },
          {
            menuName: "系统管理",
            code: "system",
            level: 1,
            children: [
              {
                menuName: "角色管理",
                path: "/SystemInfo/role/RoleList",
                code: "role:query",
                level: 2,
                authIndex: 252,
              },
              {
                menuName: "用户管理",
                path: "/SystemInfo/SystemUser/UserList",
                code: "systemUser:query",
                level: 2,
                authIndex: 11,
              },
              {
                menuName: "用户信息",
                path: "/SystemInfo/profiles/ProfilesList",
                code: "profiles:query",
                level: 22,
              },
              {
                menuName: "菜单管理",
                path: "/SystemInfo/systemFunction/SystemFunctionTree",
                code: "systemFunction:query",
                level: 2,
                authIndex: 26,
              },
              {
                menuName: "编码规则",
                path: "/SystemInfo/EncodingRules/EncodingRulesList",
                code: "encodingRules:query",
                level: 2,
                authIndex: 36,
              },
            ],
          },
        ],
        authMenus: [],
      };
    },
    mounted() {
      this.initMenu();
    },
    methods: {
      initMenu() {
        this.menus.forEach((item) => {
          if (item.level === 1) {
            item.children = (item.children || []).filter((child) => {
              if (child.authIndex instanceof Array) {
                for (let item of child.authIndex) {
                  if (this.$auth(item)) {
                    return true;
                  }
                }
                return false;
              } else {
                return this.$auth(child.authIndex);
              }
            });
            if (item.children.length > 0) {
              this.authMenus.push(item);
            }
          }
        });
        this.menusCopy = JSON.stringify(this.authMenus);
      },

      goto(menu) {
        this.$router.push({ path: menu.path });
      },

      inputHandle() {
        var that = this;
        let indexs = [];
        let arr = JSON.parse(that.menusCopy);
        let newArr = [];
        if (that.menuName) {
          arr.forEach((item) => {
            if (item.children.length) {
              let result = item.children.filter((item) => item.menuName.indexOf(that.menuName.toUpperCase()) !== -1);
              if (result.length) {
                newArr.push(item);
                item.children = result;
              }
            }
          });
          that.authMenus = newArr;
          setTimeout(function() {
            if (that.authMenus.length) {
              that.authMenus.forEach((item) => {
                indexs.push(item.menuName);
              });
              that.defaultOpens = indexs;
            }
          }, 100);
        } else {
          that.authMenus = JSON.parse(that.menusCopy);
          that.defaultOpens = [];
        }
      },
    },
  };
</script>

<style lang="scss">
@import "../../style/variables";
// 菜单展开样式
.vm-sidebar {
  width: $sidebar-width;
  background-color: #00101c;
  overflow: hidden;
  .logo {
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    color: #fff;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 1px;
    .el-badge__content.is-fixed {
      top: 30px;
      right: 0px;
      border: none;
    }
  }
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-menu {
    background-color: #00101c;
    border-right: 0;
    .el-submenu__title,
    .el-menu_item,
    .el-menu-item {
      color: #fff;
      height: 50px;
      line-height: 50px;
      &:hover {
        background-color: #3555cc;
      }
      border-bottom: 1px solid rgb(23, 25, 33);
    }

    .el-menu-item.is-active {
      background-color: #3555cc;
    }
    .is-opened ul {
      background-color: #000c17;
    }
    .el-menu-item {
      padding-left: 40px !important;
    }

    .el-submenu__title i {
      color: #fff;
      margin-right: 8px;
    }

    .el-icon-arrow-down {
      margin-top: -6px;
    }
  }
}

// 菜单收起样式
.vm-sidebar-close {
  width: $sidebar-width-close;
  .not-select,
  .el-submenu__icon-arrow {
    display: none;
  }
  .icon-lg {
    font-size: 20px;
  }
  .el-menu {
    border-right: none;
  }
}

.menuSearch {
  padding: 5px 10px 0 10px;
  margin-bottom: 5px;
  .el-input__inner {
    border-radius: 20px;
    background-color: #444;
    border: none;
    color: #fff;
  }
}
</style>
